module.exports = __webpack_public_path__ + "img/Lot1.f1590778.jpg";